import React, {Component} from "react"
import {Button, DropdownItem, DropdownMenu, DropdownToggle, Input, Spinner, UncontrolledDropdown} from "reactstrap"
import DataTable from "react-data-table-component"
import classnames from "classnames"
import ReactPaginate from "react-paginate"
import {Check, ChevronDown, ChevronLeft, ChevronRight, Plus, RotateCw} from "react-feather"
import Sidebar from "./DataListSidebar"
import Checkbox from "../checkbox/CheckboxesVuexy"
import {FormattedMessage} from "react-intl";
import {GetRequest} from "../../request";
import Notify from "./../noty/notify"
import {logout} from "../../../redux/actions/auth/loginActions";
import {connect} from "react-redux";
import ReactCountryFlag from "react-country-flag";
import Cookies from "universal-cookie";

const CustomHeader = props => {
    let langArr = {
        "en": "English",
        "fa": "Persian"
    }
    return (
        <div className="data-list-header d-flex justify-content-between flex-wrap">
            {/*<div className="actions-left d-flex flex-wrap">*/}
            {/*    {props.newItem &&*/}
            {/*        <Button*/}
            {/*            className="add-new-btn"*/}
            {/*            color="primary"*/}
            {/*            onClick={() => props.handleSidebar(true, true)}*/}
            {/*            outline>*/}
            {/*            <Plus size={15}/>*/}
            {/*            <span className="align-middle">*/}
            {/*            <FormattedMessage id="Add New"/>*/}
            {/*        </span>*/}
            {/*        </Button>*/}
            {/*    }*/}
            {/*</div>*/}
            <div className="actions-right d-flex flex-wrap mt-sm-0 mt-2">
                {/*<div className="my-auto mr-2 ml-2">*/}
                {/*    <RotateCw size={15} onClick={props.refreshTable} className="cursor-pointer"/>*/}
                {/*</div>*/}
                {/*{!props.localeDisabled &&*/}
                {/*    <UncontrolledDropdown className="data-list-rows-dropdown mr-1 d-md-block d-none">*/}
                {/*        <DropdownToggle color="" className="sort-dropdown">*/}
                {/*            <ReactCountryFlag*/}
                {/*                className="country-flag"*/}
                {/*                countryCode={*/}
                {/*                    props.locale === "en"*/}
                {/*                        ? "us"*/}
                {/*                        : props.locale === "fa" ? "ir" : props.locale*/}
                {/*                }*/}
                {/*                svg*/}
                {/*            />*/}
                {/*            <span className="d-sm-inline-block d-none text-capitalize align-middle ml-50">*/}
                {/*            <FormattedMessage id={langArr[props.locale]}/>*/}
                {/*        </span>*/}
                {/*            <ChevronDown size={15}/>*/}
                {/*        </DropdownToggle>*/}
                {/*        <DropdownMenu tag="div" right>*/}
                {/*            <DropdownItem*/}
                {/*                tag="a"*/}
                {/*                onClick={() => props.switchLanguage("en")}>*/}
                {/*                <ReactCountryFlag className="country-flag" countryCode="us" svg/>*/}
                {/*                <span className="ml-1"><FormattedMessage id="English"/></span>*/}
                {/*            </DropdownItem>*/}
                {/*            <DropdownItem*/}
                {/*                tag="a"*/}
                {/*                onClick={() => props.switchLanguage("fa")}>*/}
                {/*                <ReactCountryFlag className="country-flag" countryCode="ir" svg/>*/}
                {/*                <span className="ml-1"><FormattedMessage id="Persian"/></span>*/}
                {/*            </DropdownItem>*/}
                {/*        </DropdownMenu>*/}
                {/*    </UncontrolledDropdown>*/}
                {/*}*/}
                {/*<div className="filter-section">*/}
                {/*    <Input type="text" onChange={(e) => props.handleFilter(e)}/>*/}
                {/*</div>*/}
            </div>
        </div>
    )
}

const selectedStyle = {
    rows: {
        selectedHighlighStyle: {
            backgroundColor: "rgba(115,103,240,.05)",
            color: "#7367F0 !important",
            boxShadow: "0 0 1px 0 #7367F0 !important",
            "&:hover": {
                transform: "translateY(0px) !important"
            }
        }
    }
}

class ListContact extends Component {

    constructor(props) {
        super(props);
        const cookies = new Cookies();
        if (!cookies.get('locale'))
            cookies.set('locale', "fa", {path: '/'});
        this.state = {
            urlData: this.props.urlData ? this.props.urlData : "",
            urlSearch: this.props.urlSearch ? this.props.urlSearch : "",
            data: this.props.customData ? this.props.data : [],
            totalPages: 0,
            currentPage: 1,
            columns: this.props.Col ? this.props.Col : [],
            value: "",
            rowsPerPage: 10,
            sidebar: this.props.sidebar ? this.props.sidebar : false,
            selected: [],
            totalRecords: 0,
            form: 0,
            to: 0,
            addNew: "",
            token: localStorage.getItem('token') ? localStorage.getItem('token') : '',
            search: "",
            reload: true,
            reloadManual: false,
            locale: cookies.get('locale') ? cookies.get('locale') : "fa",
            localeDisabled: this.props.localeDisabled ? this.props.localeDisabled : false,
            metaData: this.props.metaData ? this.props.metaData : false,
            customUrl: this.props.customUrl ? this.props.customUrl : false,
            enableSidebar: this.props.enableSidebar ? this.props.enableSidebar : true,
            callBackData: this.props.callBackData
        }
        this.handlePagination = this.handlePagination.bind(this);
    }

    componentDidMount() {
        // if (!this.props.customData)
        this.getData();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        let parent = this;
        if (prevState.sidebar !== this.props.sidebar && this.props.sidebar !== undefined) {
            this.setState({
                sidebar: this.props.sidebar
            })
            if (this.state.reload)
                this.refreshTable();
        }
        if (prevState.reloadManual !== this.props.reload) {
            this.setState({
                reloadManual: this.props.reload
            })
            if (!this.state.reload)
                this.refreshTable();
        }
        if (prevState.urlData !== this.props.urlData) {
            this.setState({
                urlData: this.props.urlData
            }, function () {
                parent.refreshTable();
            })
        }
        if (prevState.customUrl !== this.props.customUrl)
            this.setState({
                customUrl: this.props.customUrl
            })
    }

    switchLanguage = _locale => {
        const cookies = new Cookies();
        cookies.set('locale', _locale, {path: '/'});
        this.setState({
            reload: true,
            locale: _locale
        }, function () {
            this.getData();
        })
    }

    refreshTable = () => {
        this.setState({
            reload: true
        }, function () {
            this.getData();
        })
    }

    handleFilter = e => {
        let parent = this;
        this.setState({
            search: e.target.value
        }, function () {
            this.setState({
                reload: true
            }, function () {
                parent.getData();
            })
        })
    }

    handleRowsPerPage = value => {
        let parent = this;
        this.setState({
            rowsPerPage: value
        }, function () {
            this.setState({
                reload: true
            }, function () {
                parent.getData();
            })
        })
    }

    handleSidebar = (boolean, addNew = false) => {
        this.setState({sidebar: boolean})
        this.props.onChangeSidebar(boolean);
        if (addNew === true) {
            this.setState({addNew: true})
            this.props.newForm && this.props.newForm()
        }
    }

    handlePagination(data) {
        const page = data.selected >= 0 ? data.selected + 1 : 0;
        let parent = this;
        this.setState(() => ({
            currentPage: page
        }), function () {
            if (parent.state.data.length > 0) {
                this.setState({
                    reload: true
                }, function () {
                    parent.getData();
                })
            }
        });
    }

    getData = () => {
        let parent = this;
        let search = this.state.search;
        let url;
        if (this.state.customUrl)
            url = this.state.urlData + '&page=' + this.state.currentPage + '&per_page=' + this.state.rowsPerPage;
        else
            url = this.state.urlData + '?page=' + this.state.currentPage + '&per_page=' + this.state.rowsPerPage;
        if (search) {
            url += "&s=" + search;
        }
        GetRequest("/api/moderate/contacts",
            {
                'Authorization': this.state.token
            }, true).then((response) => {
            let result = response.data;
            if (result.ok) {
                parent.setState({
                    data: result.data.data,
                })

            }
        }).catch(function (error) {
            if (error.response) {
                if (error.response.status === 401) {
                    parent.props.logout();
                    Notify('error', 'top-right', "دسترسی غیرمجاز");
                } else
                    Notify('error', 'top-right', "خطایی رخ داده است");
            }
        }).finally(() => {
            this.setState({
                reload: false
            })
        })
    }



    ConvertMetaData(data) {
        let array = [];
        let parent = this;
        array = data.map(function (item, index) {
            let obj = [];
            item[parent.state.metaData].map(function (meta, index) {
                obj[meta['key']] = meta['value'];
            });
            obj["request_id"] = item[parent.state.metaData][0].request_id;
            return obj;
        });
        return array
    }

    render() {
        let {
            columns,
            data,
            rowsPerPage,
            sidebar,
            totalRecords,
            from,
            to
        } = this.state;
        return (
            <div className={classnames({
                "data-list list-view": true,
                "refreshing": this.state.reload
            })}>
                {this.state.reload &&
                    <div className="box-spinner">
                        <Spinner color="primary" className="reload-spinner"/>
                    </div>
                }
                <DataTable
                    columns={columns}
                    data={data}
                    noHeader
                    subHeader
                    // selectableRows
                    responsive
                    pointerOnHover
                    // selectableRowsHighlight
                    // onSelectedRowsChange={data =>
                    //     this.setState({selected: data.selectedRows})
                    // }
                    noDataComponent={<FormattedMessage id="NoDataToShow"/>}
                    customStyles={selectedStyle}
                    subHeaderComponent={
                        <CustomHeader
                            newItem={this.props.newItem}
                            handleSidebar={this.handleSidebar}
                            handleFilter={this.handleFilter}
                            handleRowsPerPage={this.handleRowsPerPage}
                            refreshTable={this.refreshTable}
                            switchLanguage={this.switchLanguage}
                            locale={this.state.locale}
                            localeDisabled={this.state.localeDisabled}
                            rowsPerPage={rowsPerPage}
                            total={totalRecords}
                            from={from}
                            to={to}
                        />
                    }
                    sortIcon={<ChevronDown/>}
                    selectableRowsComponent={Checkbox}
                    selectableRowsComponentProps={{
                        color: "primary",
                        icon: <Check className="vx-icon" size={12}/>,
                        label: "",
                        size: "sm"
                    }}
                />
                <ReactPaginate
                    previousLabel={<ChevronLeft size={15}/>}
                    nextLabel={<ChevronRight size={15}/>}
                    breakLabel="..."
                    breakClassName="break-me"
                    pageCount={this.state.totalPages}
                    containerClassName="vx-pagination separated-pagination pagination-start pagination-sm mb-0 mt-2"
                    activeClassName="active"
                    initialPage={this.state.currentPage - 1}
                    forcePage={this.state.currentPage - 1}
                    onPageChange={this.handlePagination}
                />
                {this.state.enableSidebar &&
                    <>
                        <Sidebar
                            show={sidebar}
                            handleSidebar={this.handleSidebar}
                            view={this.props.viewForm}
                            clearForm={this.props.newForm}
                        />
                        <div
                            className={classnames("data-list-overlay", {
                                show: sidebar
                            })}
                            onClick={() => this.handleSidebar(false, true)}
                        />
                    </>
                }
            </div>
        )
    }
}

const mapStateToProps = state => {
    return state
}
export default connect(mapStateToProps, {logout})(ListContact)
